import * as cuBuilding from '../../redux/reducers/building_pricing/pricingReducer';
import { const_var, params } from '../../redux/reducers/reducer';
const setPricingDataForLeantoComparision = (state, response, type, flag, iiD) => {
    // let responseStatus = (flag==true && const_var.CallApionAction==false)?response.status:response.success;
    // console.log(response,"responseStatus");
    // if (responseStatus == true) {

    let dataNew = "";
    // console.log({response});
    if (type == "addLeftLean") {
        const_var.leanGetDataLeftComparision = (response.success == true) ? response.data : const_var.leanGetDataLeft;
        // console.log(const_var.leanGetDataLeftComparision ,"const_var.leanGetDataLeftComparision");
        if (const_var.leanGetDataLeftComparision.central_side != undefined && const_var.leanGetDataLeftComparision.central_side.length > 0) {
            const_var.ComparisionDataArray[iiD].pricing_data.side = const_var.leanGetDataLeftComparision.central_side;
        }
        if (const_var.leanGetDataLeftComparision.central_end != undefined && const_var.leanGetDataLeftComparision.central_end.length > 0) {
            const_var.ComparisionDataArray[iiD].pricing_data.end = const_var.leanGetDataLeftComparision.central_end;
        }
        if (const_var.leanGetDataLeftComparision.central_utility_side != undefined && const_var.leanGetDataLeftComparision.central_utility_side.length > 0) {
            const_var.ComparisionDataArray[iiD].pricing_data.utility_side = const_var.leanGetDataLeftComparision.central_utility_side;
        }
        if (const_var.leanGetDataLeftComparision.end_combo_v3 != undefined && const_var.leanGetDataLeftComparision.end_combo_v3.length > 0) {
            const_var.ComparisionDataArray[iiD].pricing_data.end_combo_v3 = const_var.leanGetDataLeftComparision.end_combo_v3;
        }
        if (const_var.leanGetDataLeftComparision.side_combo_v3 != undefined && const_var.leanGetDataLeftComparision.side_combo_v3.length > 0) {
            const_var.ComparisionDataArray[iiD].pricing_data.side_combo_v3 = const_var.leanGetDataLeftComparision.side_combo_v3;
        }
        if (const_var.leanGetDataLeftComparision.central_trusses != undefined && const_var.leanGetDataLeftComparision.central_trusses.length > 0) {
            const_var.ComparisionDataArray[iiD].pricing_data.trusses = const_var.leanGetDataLeftComparision.central_trusses;
        }
        if (response.success && response.data.building_structure?.length && response.data.building_structure[0].start_length) {
            let minLength = Math.round(response.data.building_structure[0].start_length / 2);
            if (minLength > params.lean_p_d) {
                const_var.ComparisionDataArray[iiD].paramsData.lean_p_d = minLength;
            }
        }
        if (response.success && response.data.building_structure?.length && response.data.building_structure[0].min_width) {
            let minWidth = response.data.building_structure[0].min_width;
            if (minWidth > params.lean_p_w) {
                const_var.ComparisionDataArray[iiD].paramsData.lean_p_w = minWidth;
            }
        }
        if (response.success && response.data.building_structure?.length && response.data.building_structure[0].min_height) {
            let minHeight = response.data.building_structure[0].min_height;
            if (minHeight > params.lean_p_h) {
                const_var.ComparisionDataArray[iiD].paramsData.lean_p_h = minHeight;
            // }else{
            //     let msn_id = Number(iiD.split("_")[0])
            //     let straightRoofval = utils.straightRoofDistance(params.p_r_s, params.p_r_p, params.b_l_t_r_p, const_var.roofRegularDst, msn_id);
            //     const_var.ComparisionDataArray[iiD].paramsData.lean_p_h = const_var.ComparisionDataArray[iiD].paramsData.lean_p_h - straightRoofval    
            }
        }
        dataNew = const_var.leanGetDataLeftComparision;
        if (const_var.compareMainBuildingPriceRes.connection_fees != undefined && const_var.compareMainBuildingPriceRes.connection_fees.length == 0) {
            const_var.compareMainBuildingPriceRes.connection_fees = const_var.leanGetDataLeftComparision.connection_fees;
        }
        if (const_var.leanGetDataLeftComparision.building_structure!=undefined && const_var.leanGetDataLeftComparision.building_structure.length > 0) {
            if (Object.keys(const_var.leanGetDataLeftComparision.building_structure[0].conditions).length !== 0) {
                const_var.conditionArrForLeanCompare['left'] = const_var.leanGetDataLeftComparision.building_structure[0].conditions['Leg_Height_condition'];
            }
        }
        cuBuilding.cPforLLeanOnlyComparision(const_var.leanGetDataLeftComparision, iiD);

    } else if (type == "addFrontLean") {
        const_var.leanGetDataFrontComparision = (response.success == true) ? response.data : const_var.leanGetDataFront;
        if (const_var.leanGetDataFrontComparision.central_side != undefined && const_var.leanGetDataFrontComparision.central_side.length > 0) {
            const_var.ComparisionDataArray[iiD].pricing_data.side = const_var.leanGetDataFrontComparision.central_side;
        }
        if (const_var.leanGetDataFrontComparision.central_end != undefined && const_var.leanGetDataFrontComparision.central_end.length > 0) {
            const_var.ComparisionDataArray[iiD].pricing_data.end = const_var.leanGetDataFrontComparision.central_end;
        }
        if (const_var.leanGetDataFrontComparision.central_utility_side != undefined && const_var.leanGetDataFrontComparision.central_utility_side.length > 0) {
            const_var.ComparisionDataArray[iiD].pricing_data.utility_side = const_var.leanGetDataFrontComparision.central_utility_side;
        }
        if (const_var.leanGetDataFrontComparision.end_combo_v3 != undefined && const_var.leanGetDataFrontComparision.end_combo_v3.length > 0) {
            const_var.ComparisionDataArray[iiD].pricing_data.end_combo_v3 = const_var.leanGetDataFrontComparision.end_combo_v3;
        }
        if (const_var.leanGetDataFrontComparision.side_combo_v3 != undefined && const_var.leanGetDataFrontComparision.side_combo_v3.length > 0) {
            const_var.ComparisionDataArray[iiD].pricing_data.side_combo_v3 = const_var.leanGetDataFrontComparision.side_combo_v3;
        }
        if (const_var.leanGetDataFrontComparision.central_trusses != undefined && const_var.leanGetDataFrontComparision.central_trusses.length > 0) {
            const_var.ComparisionDataArray[iiD].pricing_data.trusses = const_var.leanGetDataFrontComparision.central_trusses;
        }
        if (response.success && response.data.building_structure?.length && response.data.building_structure[0].start_length) {
            let minLength = Math.round(response.data.building_structure[0].start_length / 2);
            if (minLength > params.leanF_p_d) {
                const_var.ComparisionDataArray[iiD].paramsData.leanF_p_d = minLength;
            }
        }
        if (response.success && response.data.building_structure?.length && response.data.building_structure[0].min_width) {
            let minWidth = response.data.building_structure[0].min_width;
            if (minWidth > params.leanF_p_w) {
                const_var.ComparisionDataArray[iiD].paramsData.leanF_p_w = minWidth;
            }
        }
        if (response.success && response.data.building_structure?.length && response.data.building_structure[0].min_height) {
            let minHeight = response.data.building_structure[0].min_height;
            if (minHeight > params.leanF_p_h) {
                const_var.ComparisionDataArray[iiD].paramsData.leanF_p_h = minHeight;
            }
        }

        dataNew = const_var.leanGetDataFrontComparision;
        if (const_var.compareMainBuildingPriceRes.connection_fees != undefined && const_var.compareMainBuildingPriceRes.connection_fees.length == 0) {
            const_var.compareMainBuildingPriceRes.connection_fees = const_var.leanGetDataFrontComparision.connection_fees;
        }
        if (const_var.leanGetDataFrontComparision.building_structure!=undefined && const_var.leanGetDataFrontComparision.building_structure.length > 0) {
            if (Object.keys(const_var.leanGetDataFrontComparision.building_structure[0].conditions).length !== 0) {
                const_var.conditionArrForLeanCompare['front'] = const_var.leanGetDataFrontComparision.building_structure[0].conditions['Leg_Height_condition'];
            }
        }

        cuBuilding.cPforFLeanOnlyComparision(const_var.leanGetDataFrontComparision, iiD);
  } else if (type == "addBackLean") {
        const_var.leanGetDataBackComparision = (response.success == true) ? response.data : const_var.leanGetDataFront;
        if (const_var.leanGetDataBackComparision.central_side != undefined && const_var.leanGetDataBackComparision.central_side.length > 0) {
            const_var.ComparisionDataArray[iiD].pricing_data.side = const_var.leanGetDataBackComparision.central_side;
        }
        if (const_var.leanGetDataBackComparision.central_end != undefined && const_var.leanGetDataBackComparision.central_end.length > 0) {
            const_var.ComparisionDataArray[iiD].pricing_data.end = const_var.leanGetDataBackComparision.central_end;
        }
        if (const_var.leanGetDataBackComparision.central_utility_side != undefined && const_var.leanGetDataBackComparision.central_utility_side.length > 0) {
            const_var.ComparisionDataArray[iiD].pricing_data.utility_side = const_var.leanGetDataBackComparision.central_utility_side;
        }
        if (const_var.leanGetDataBackComparision.end_combo_v3 != undefined && const_var.leanGetDataBackComparision.end_combo_v3.length > 0) {
            const_var.ComparisionDataArray[iiD].pricing_data.end_combo_v3 = const_var.leanGetDataBackComparision.end_combo_v3;
        }
        if (const_var.leanGetDataBackComparision.side_combo_v3 != undefined && const_var.leanGetDataBackComparision.side_combo_v3.length > 0) {
            const_var.ComparisionDataArray[iiD].pricing_data.side_combo_v3 = const_var.leanGetDataBackComparision.side_combo_v3;
        }
        if (const_var.leanGetDataBackComparision.central_trusses != undefined && const_var.leanGetDataBackComparision.central_trusses.length > 0) {
            const_var.ComparisionDataArray[iiD].pricing_data.trusses = const_var.leanGetDataBackComparision.central_trusses;
        }
        if (response.success && response.data.building_structure?.length && response.data.building_structure[0].start_length) {
            let minLength = Math.round(response.data.building_structure[0].start_length / 2);
            if (minLength > params.leanB_p_d) {
                const_var.ComparisionDataArray[iiD].paramsData.leanB_p_d = minLength;
            }
        }
        if (response.success && response.data.building_structure?.length && response.data.building_structure[0].min_width) {
            let minWidth = response.data.building_structure[0].min_width;
            if (minWidth > params.leanB_p_w) {
                const_var.ComparisionDataArray[iiD].paramsData.leanB_p_w = minWidth;
            }
        }
        if (response.success && response.data.building_structure?.length && response.data.building_structure[0].min_height) {
            let minHeight = response.data.building_structure[0].min_height;
            if (minHeight > params.leanB_p_h) {
                const_var.ComparisionDataArray[iiD].paramsData.leanB_p_h = minHeight;
            }
        }
        dataNew = const_var.leanGetDataBackComparision;
        if (const_var.compareMainBuildingPriceRes.connection_fees != undefined && const_var.compareMainBuildingPriceRes.connection_fees.length == 0) {
            const_var.compareMainBuildingPriceRes.connection_fees = const_var.leanGetDataBackComparision.connection_fees;
        }
        if (const_var.leanGetDataBackComparision.building_structure!=undefined && const_var.leanGetDataBackComparision.building_structure.length > 0) {
            if (Object.keys(const_var.leanGetDataBackComparision.building_structure[0].conditions).length !== 0) {
                const_var.conditionArrForLeanCompare['back'] = const_var.leanGetDataBackComparision.building_structure[0].conditions['Leg_Height_condition'];
            }
        }

        cuBuilding.cPforBLeanOnlyComparision(const_var.leanGetDataBackComparision, iiD);

    } else if (type == "addRightLean") {
        const_var.leanGetDataRightComparision = (response.success == true) ? response.data : const_var.leanGetDataRight;
        if (const_var.leanGetDataRightComparision.central_side != undefined && const_var.leanGetDataRightComparision.central_side.length > 0) {
            const_var.ComparisionDataArray[iiD].pricing_data.side = const_var.leanGetDataRightComparision.central_side;
        }
        if (const_var.leanGetDataRightComparision.central_end != undefined && const_var.leanGetDataRightComparision.central_end.length > 0) {
            const_var.ComparisionDataArray[iiD].pricing_data.end = const_var.leanGetDataRightComparision.central_end;
        }
        if (const_var.leanGetDataRightComparision.central_utility_side != undefined && const_var.leanGetDataRightComparision.central_utility_side.length > 0) {
            const_var.ComparisionDataArray[iiD].pricing_data.utility_side = const_var.leanGetDataRightComparision.central_utility_side;
        }
        if (const_var.leanGetDataRightComparision.end_combo_v3 != undefined && const_var.leanGetDataRightComparision.end_combo_v3.length > 0) {
            const_var.ComparisionDataArray[iiD].pricing_data.end_combo_v3 = const_var.leanGetDataRightComparision.end_combo_v3;
        }
        if (const_var.leanGetDataRightComparision.side_combo_v3 != undefined && const_var.leanGetDataRightComparision.side_combo_v3.length > 0) {
            const_var.ComparisionDataArray[iiD].pricing_data.side_combo_v3 = const_var.leanGetDataRightComparision.side_combo_v3;
        }
        if (const_var.leanGetDataRightComparision.central_trusses != undefined && const_var.leanGetDataRightComparision.central_trusses.length > 0) {
            const_var.ComparisionDataArray[iiD].pricing_data.trusses = const_var.leanGetDataRightComparision.central_trusses;
        }
        if (response.success && response.data.building_structure?.length && response.data.building_structure[0].start_length) {
            let minLength = Math.round(response.data.building_structure[0].start_length / 2);
            if (minLength > params.leanR_p_d) {
                const_var.ComparisionDataArray[iiD].paramsData.leanR_p_d = minLength;
            }
        }
        if (response.success && response.data.building_structure?.length && response.data.building_structure[0].min_width) {
            let minWidth = response.data.building_structure[0].min_width;
            if (minWidth > params.leanR_p_w) {
                const_var.ComparisionDataArray[iiD].paramsData.leanR_p_w = minWidth;
            }
        }
        if (response.success && response.data.building_structure?.length && response.data.building_structure[0].min_height) {

            
            let minHeight = response.data.building_structure[0].min_height;            
            if (minHeight > params.leanR_p_h) {
                const_var.ComparisionDataArray[iiD].paramsData.leanR_p_h = minHeight;
            // }else{
            //     let msn_id = Number(iiD.split("_")[0])
            //     let straightRoofval = utils.straightRoofDistance(params.p_r_s, params.p_r_p, params.b_l_t_r_pR, const_var.roofRegularDst, msn_id);
            //     const_var.ComparisionDataArray[iiD].paramsData.leanR_p_h = const_var.ComparisionDataArray[iiD].paramsData.leanR_p_h - straightRoofval    
            }
        }
        dataNew = const_var.leanGetDataRightComparision;
        if (const_var.compareMainBuildingPriceRes.connection_fees != undefined && const_var.compareMainBuildingPriceRes.connection_fees.length == 0) {
            const_var.compareMainBuildingPriceRes.connection_fees = const_var.leanGetDataRightComparision.connection_fees;
        }
        if (const_var.leanGetDataRightComparision.building_structure!=undefined && const_var.leanGetDataRightComparision.building_structure.length > 0) {
            if (Object.keys(const_var.leanGetDataRightComparision.building_structure[0].conditions).length !== 0) {
                const_var.conditionArrForLeanCompare['right'] = const_var.leanGetDataRightComparision.building_structure[0].conditions['Leg_Height_condition'];
            }
        }

        cuBuilding.cPforRLeanOnlyComparision(const_var.leanGetDataRightComparision, iiD);

    }
    // console.log(const_var.leanGetDataRightComparision,"const_var.leanGetDataRightComparision");
    state.const_var.comparisionLoadermfg1 = false;
    state.const_var.comparisionLoadermfg2 = false;

}
export const NoCompareData=(state,action)=>{
    if (action.mfgindex == "_1") {
				state.const_var.NoCompareData1 = true;
				state.const_var.comparisionLoadermfg1 = false;
			}
			if (action.mfgindex == "_2") {
				state.const_var.NoCompareData2 = true;
				state.const_var.comparisionLoadermfg2 = false;
			}

			params[`${"showCompareMnfList"}${action.mfgindex}`] = true;
			for (let key in const_var.ComparisionDataArray) {
				if (key.includes(action.mfgindex)) {
					delete const_var.ComparisionDataArray[key];
				}
			}

			return {
				...state,
				action,
				newColor: state.const_var.comparisionLoadermfg1 + state.const_var.comparisionLoadermfg2 + state.const_var.NoCompareData1 + state.const_var.NoCompareData2 + const_var.ComparisionDataArray
			};
}
export default setPricingDataForLeantoComparision;



